import { ResponsiveImage } from "@omni/types/components/image/responsiveImage.type";
import { ImageProps } from "@omni/types/components/props/image.props";
import { ModelMapper } from "@omni/types/utils/modelMapper";

type SeperateModelParams = {
    image: ResponsiveImage;
    mobileImage?: ResponsiveImage;
};

export const toImageProps: ModelMapper<SeperateModelParams, ImageProps> = ({
    image,
    mobileImage
}) => {
    /**
     * ImageComponent in AEM gebruikt renditions om src te bepalen,
     * geen renditions, geen src
     * logica in ImageComponent in packages/components kan dit afhandelen
     */
    return {
        alt: image.altText || "",
        lazy: image.lazyLoading,
        height: image.dimension.height,
        width: image.dimension.width,
        renditions: image.renditions,
        src: undefined,
        mobileRenditions: mobileImage?.renditions,
        mobileHeight: mobileImage?.dimension.height,
        mobileWidth: mobileImage?.dimension.width,
        mobileSrc: undefined
    };
};
